import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Número de telefone',
      placeholder: 'Introduza o número de telefone',
    },
    email: {
      label: 'Endereço de email',
      placeholder: 'Introduza o endereço de email',
    },
  },
  channel_chooser: {
    title: 'Enviar código via',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratuito, entrega mais rápida',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Mensagem de texto normal',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Email',
      subtitle: 'Código diretamente na sua caixa de entrada',
    },
  },
  otp: {
    title: 'Introduza o código de verificação',
    send_code: 'Enviar código',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Enviado via <strong>WhatsApp</strong> para <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Enviado via <strong>SMS</strong> para <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Enviado via <strong>e-mail</strong> para <strong>{{phone}}</strong>',
    },
    sent_to: 'Enviado para',
    resend: {
      title: 'Não recebeu o código?',
      countdown: 'Reenviar em',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Não recebeu o código por e-mail?',
          button: 'Reenviar por email',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Não recebeu o código?',
          button: 'Reenviar por SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Não recebeu o código?',
          button: 'Reenviar por WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Enviar por SMS',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Enviar por WhatsApp',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Foi enviada uma mensagem com um código de verificação para o seu telefone. Introduza o código para continuar.',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Por favor, introduza o código enviado para: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Foi enviada uma mensagem WhatsApp com um código de verificação para o seu telefone. Introduza o código para continuar.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Dica: Verifique a sua caixa de entrada e a pasta de spam.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Atenção — o código é enviado por <strong>{{sender}}</strong>, o nosso parceiro tecnológico.',
    business_account: 'Conta empresarial',
    message: '<strong>123456</strong> é o seu código de verificação. Por segurança, não partilhe este código.',
  },
  error_messages: {
    frequent_requests:
      'Por favor, verifique as suas mensagens. Já enviámos o código para o número indicado. Se não o recebeu, verifique o número de telefone ou tente novamente em 10 minutos.',
    frequent_requests_email:
      'Verifique a sua caixa de entrada e a pasta de spam. Já enviámos o código para esse endereço. Se não chegou, tente novamente dentro de 10 minutos.',
    invalid_number: 'Número inválido. Por favor, tente novamente.',
    invalid_email: 'Não foi possível enviar o código para esse endereço de email. Verifique-o e tente novamente.',
    email_not_on_file:
      'Este número de telemóvel já tem uma conta sem endereço de email. Contacte {{support_email}} para adicionar um — até lá, não conseguimos enviar códigos para este número por email.',
    turnstile_required: 'Por favor, conclua a verificação antes de solicitar um novo código.',
    generic_error: 'Ups, algo correu mal. Por favor, atualize a página e tente novamente.',
    change_phone_number_unsuccessful: 'Falha ao alterar o número de telefone. Por favor, tente novamente.',
  },
  toasts: {
    code_sent: 'Código enviado',
  },
};
